import { RouteType } from "types/RouteType";

export const generalLedgerRoute: RouteType = {
  name: "General Ledger",
  path: "/accounting/general-ledger",
  layout: "/app",
  viewportCard: {
    header: {
      title: "General Ledger",
      enableRefreshButton: true,
      enableBackButton: true,
      color: "primary",
      component: () => import("./GeneralLedger.Header"),
    },
    body: {
      component: () => import("./GeneralLedger.Body"),
      grayBackground: true,
    },
  },
  dialogs: [
    {
      name: "TransactionDetailDialog",
      title: "Transaction Details",
      component: () => import("./dialogs/TransactionDetailDialog"),
      height: 860,
      maxWidth: "md",
    },
    {
      name: "ExportDialog",
      title: "Export Report",
      component: () => import("./dialogs/ExportDialog"),
      height: 670,
    },
    {
      name: "ColumnConfigDialog",
      title: "Customize Columns",
      component: () => import("./dialogs/ColumnConfigDialog"),
      height: 580,
    },
    {
      name: "SaveConfigDialog",
      title: "Save Report Configuration",
      component: () => import("./dialogs/SaveConfigDialog"),
      height: 480,
    },
  ],
  group: "Accounting",
  requiresAuth: true,
  requiresAdmin: false,
  requiresPermission: false,
  enableAutoFind: false,
  beforeEnter: async ({ rootStore }) => {
    const store = (rootStore as any).generalLedgerStore;
    if (store && typeof store === "object") {
      // Load persisted configurations (Phase 7)
      if ("loadPersistedConfigurations" in store) {
        store.loadPersistedConfigurations();
      }
      // Load transaction data
      if ("loadData" in store) {
        await store.loadData();
      }
    }
    return true;
  },
  onParamsChange: async ({ rootStore, queryParams, previousQueryParams }) => {
    const DIALOG_KEYS = ["dialogName", "dialogTab", "dialogContext"];
    const isDialogOnlyChange = Object.keys({ ...previousQueryParams, ...queryParams })
      .every((key) => DIALOG_KEYS.includes(key));
    if (isDialogOnlyChange) return;

    const store = (rootStore as any).generalLedgerStore;
    if (store && typeof store === "object" && "loadData" in store) {
      await store.loadData();
    }
  },
};

export default generalLedgerRoute;
